import React from "react";
import { Link, Typography } from "@material-ui/core";

export const Copyright = () => {
    return (
        <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            style={{
                display: 'block',
                position: 'absolute',
                bottom: '0',
                right: '0',
                width: '100%',
                background: '#eee',
                border: '1px solid #ddd',
            }}
        >
            {'Copyright © '}
            <Link color="inherit" href="https://www.ridan.ru" target='_blank'>
                Ridan
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
};